import { useCallback, useState } from 'react'
const status = ['AC', 'SU', 'EP', 'DV']
const useFilters = () => {
  const [searchBy, setSearchBy] = useState()
  const [filters, setFilters] = useState({
    sEstado: ['AC'],
    sSucursal: '',
    sCentroCosto: '',
    sGrupo: '',
    sNombre: '',
    sTipoEmpleado: '',
    sRut: '',
  })

  const handleChangeFilter = useCallback((key, value) => {
    setFilters((prevState) => ({ ...prevState, [key]: value }))
  }, [])

  const handleChangeEvent = useCallback(
    (key, event) => {
      handleChangeFilter(key, event.target.value)
    },
    [handleChangeFilter],
  )
  const handleSearchBy = useCallback(
    (value) => {
      setSearchBy(value)
      if (value) {
        if (value === 'dni') {
          handleChangeFilter('sNombre', '')
        } else if (value === 'name') {
          handleChangeFilter('sRut', '')
        }
      } else {
        handleChangeFilter('sNombre', '')
        handleChangeFilter('sRut', '')
      }
    },
    [handleChangeFilter],
  )
  const handleChangeStatus = useCallback(
    (value) => {
      const checked = value.target.checked
      const actualStatus = value.target.value

      const exist = filters.sEstado.includes(actualStatus)
      if (exist) {
        const newStatus = filters.sEstado.reduce((acc, item) => {
          if (item === actualStatus && !checked) {
            return acc
          }
          return [...acc, item]
        }, [])

        handleChangeFilter('sEstado', newStatus)
      } else {
        handleChangeFilter('sEstado', [...filters.sEstado, actualStatus])
      }
    },
    [handleChangeFilter, filters],
  )
  const handleChangeBranch = useCallback(
    (value) => {
      handleChangeFilter('sSucursal', value)
    },
    [handleChangeFilter],
  )

  const handleChangeCostCenter = useCallback(
    (value) => {
      handleChangeFilter('sCentroCosto', value)
    },
    [handleChangeFilter],
  )
  const handleChangeGroup = useCallback((value) => {
    handleChangeFilter('sGrupo', value)
  }, [])

  const handleChangeName = useCallback(
    (value) => {
      handleChangeEvent('sNombre', value)
    },
    [handleChangeFilter],
  )

  const handleChangeEmployeeType = useCallback(
    (value) => {
      handleChangeFilter('sTipoEmpleado', value)
    },
    [handleChangeFilter],
  )
  const handleChangeDni = useCallback(
    (value) => {
      handleChangeEvent('sRut', value)
    },
    [handleChangeFilter],
  )

  const handleChangeOrderBy = useCallback(
    (value) => {
      handleChangeFilter('sOrderby', value)
    },
    [handleChangeFilter],
  )

  const handleChangeAsc = useCallback(
    (value) => {
      handleChangeFilter('bAsc', value)
    },
    [handleChangeFilter],
  )

  return {
    status,
    filters,
    searchBy,
    filtersFunctions: {
      handleSearchBy,
      handleChangeStatus,
      handleChangeBranch,
      handleChangeCostCenter,
      handleChangeGroup,
      handleChangeName,
      handleChangeEmployeeType,
      handleChangeDni,
      handleChangeOrderBy,
      handleChangeAsc,
    },
  }
}

export default useFilters
